// Mock data for Soul Kitchen website
// ====================================
// GUIDE RAPIDE :
// - coverImage : image de couverture (par défaut)
// - coverVideo : vidéo de couverture (optionnel, remplace l'image si présent)
// - media : tableau d'images ET/OU vidéos dans la galerie
// ====================================

import kamilImg from './assets/kamil.jpg';
import chaImg from './assets/charlotte.jpg';
import ChrisImg from './assets/christophe.jpg';
import teamImg from './assets/teams.jpg';

export const mockData = {
  // =====================================
  // LOGO & BRANDING
  // =====================================
  // Pour afficher votre logo au lieu du texte "Soul Kitchen" :
  // 1. Placez votre logo dans /app/frontend/public/images/
  // 2. Décommentez "logoUrl" ci-dessous
  // 
  // SPÉCIFICATIONS RECOMMANDÉES :
  // - Format : PNG (avec transparence) ou SVG
  // - Dimensions : 200px x 60px (ratio 3.3:1)
  // - Taille max : 100 KB
  // - Fond : transparent pour s'adapter à tous les arrière-plans
  // =====================================
  branding: {
    siteName: "Soul Kitchen",
    // Décommentez la ligne suivante et ajoutez le chemin de votre logo :
    logoUrl: "/images/logo.png",
    //logoUrl: null, // null = affiche le texte "Soul Kitchen"
    logoAlt: "Soul Kitchen - Traiteur végétalien", // Texte alternatif pour l'accessibilité
  },

  hero: {
    title: "Soul'Kitchen and Co.",
    subtitle: "Cuisine locale, végétale et de saison de 50 à 500 personnes",
    description: "Cuisine locale, végétalienne et de saison pour une meilleure santé et le respect de la planète.",
    image: "images/fond_hero.png",
    // VIDÉO HERO (OPTIONNEL) : Décommentez et ajoutez votre URL YouTube pour afficher une vidéo
    // videoUrl: "https://www.youtube.com/watch?v=VOTRE_VIDEO_ID"
    //videoUrl: "https://www.youtube.com/watch?v=8YBiP66CD08" // Vidéo de démonstration - remplacez par votre propre vidéo YouTube
  },

  values: [
    {
      id: 1,
      title: "Local",
      description: "Nous privilégions les producteurs locaux pour réduire notre empreinte carbone et soutenir l'économie locale."
    },
    {
      id: 2,
      title: "Végétalienne",
      description: "100% végétal, 100% savoureux. Nos plats prouvent qu'une cuisine végétale peut être raffinée et savoureuse."
    },
    {
      id: 3,
      title: "Saisonnière",
      description: "Nous cuisinons au rythme des saisons pour offrir des produits au meilleur de leur qualité gustative et nutritive."
    },
    {
      id: 4,
      title: "Santé",
      description: "Nous créons des repas équilibrés qui contribuent à une meilleure santé et à un bien-être durable."
    }
  ],

  services: [
    {
      id: 1,
      title: "Restauration collective",
      description: "Service de restauration pour associations, entreprises, personnes privées, écoles et institutions avec des menus variés adaptés aux grandes quantités (50-500 personnes).",
      capacity: "50-500 personnes"
    },
    {
      id: 2,
      title: "Événements",
      description: "Buffets et repas pour vos festivals, séminaires, conférences et événements professionnels avec une touche écologique et raffinée.",
      capacity: "Sur mesure"
    },
    {
      id: 3,
      title: "Consultations culinaires",
      description: "Accompagnement au développement de menus végétaliens adaptés à vos besoins spécifiques, et conçus pour un avenir durable.",
      capacity: "Personnalisé"
    }
  ],

  team: [
    {
      id: 1,
      name: "Kamil",
      role: "Co-Fondateur & chef",
      description: [
        "Chef passionné depuis 15 ans, j'ai quitté la haute gastronomie pour une cuisine plus consciente et sincère.",
        "Je privilégie des ingrédients locaux, de saison et bio, travaillés avec une sensibilité qui redonne du sens à l'essentiel. Ma cuisine épurée et généreuse prouve que la simplicité est une richesse révélant les saveurs vraies.",
        "Je m'engage aujourd'hui pour une alimentation vivante qui prend soin des humains autant que de la terre.",
      ],
      image: kamilImg
    },
    {
      id: 2,
      name: "Christophe",
      role: "Co-fondateur & chef",
      description: [
        "J'ai commencé à cuisiner dès l'enfance. C'est seulement depuis une dizaine d'années que mon rôle de Chef a pris son ampleur. J'ai beaucoup cuisiné pour des ateliers, stages et festivals. J'ai aussi été chef dans un restaurant végétarien prestigieux de Naples.",
        "C'est après avoir travaillé pour la rencontre Terre de Convergence (env. 5000 personnes) que l'idée de Soul'Kitchen & Co. m'est venue. Offrir une cuisine saine et savoureuse aux personnes engagées dans les transformations sociétales, c'est aussi soutenir leurs actions.",
      ],
        image: ChrisImg
    },
    {
      id: 3,
      name: "Charlotte",
      role: "Communication & graphisme",
      description: [
        "Ancienne globe-trotteuse, désormais formée à la gestion d’entreprise, je suis curieuse par nature et passionnée par les projets.",
        "Je contribue à l’aventure Soul Kitchen and Co avec engagement et bonne humeur, au cœur d’un projet où l’organisation rencontre la créativité.",
        "J’aime participer à la structuration d’initiatives vivantes, voir les idées prendre forme et évoluer au rythme d’une aventure collective et humaine, portée par des valeurs communes.",
      ]
      ,
      image: chaImg
    }
  ],

  philosophy: {
    title: "L'esprit de notre équipe",
    description: "Chez Soul'Kitchen and Co., nous croyons que bien manger est un acte de soin envers soi-même et envers la planète. Notre cuisine est un engagement quotidien pour la santé, l'environnement et le plaisir gustatif.",
    principles: [
      "Un management favorisant l'intelligence collective et la cohésion d'équipe",
      "Une entreprise 'famicale' : une paire de jumeaux, une paire de meilleurs amis, des relations de confiance et des rêves partagés à la base du projet",
      "L'envie de conjuguer entreprenariat avec engagement et responsabilité pour les générations futures",
      "Cultiver des relations durables avec les producteurs locaux",
      "Créer des recettes qui célèbrent les légumes de saison",
      "Former et sensibiliser à une alimentation consciente durant nos événements",
      "Réduire le gaspillage alimentaire à chaque étape",
      "Prouver que la cuisine végétale peut nourrir des foules stylées avec style"
    ],
    image: teamImg
  },

  // =====================================
  // ÉVÉNEMENTS - Albums par client
  // =====================================
  // NOUVEAU : Vous pouvez maintenant ajouter des VIDÉOS !
  // 
  // Pour la COUVERTURE de la card :
  //   - coverImage : URL de l'image (affichée par défaut)
  //   - coverVideo : URL YouTube (OPTIONNEL - remplace l'image si présent)
  //
  // Pour la GALERIE (images ET vidéos) :
  //   - media : tableau d'objets avec { type: 'image' | 'video', url: '...' }
  //
  // Exemple avec vidéo de couverture :
  // {
  //   coverImage: "https://...",
  //   coverVideo: "https://www.youtube.com/watch?v=XXXXX", // La vidéo sera affichée
  //   media: [
  //     { type: 'image', url: 'https://...' },
  //     { type: 'video', url: 'https://www.youtube.com/watch?v=YYYYY' },
  //   ]
  // }
  // =====================================

  events: [
    {
      id: 1,
      clientName: "TechCorp France",
      eventType: "Restauration collective",
      date: "Juin 2024",
      location: "Paris",
      guestCount: "800 personnes",
      description: "Service de restauration quotidienne pour l'entreprise TechCorp pendant 3 mois.",
      coverImage: "https://images.unsplash.com/photo-1555939594-58d7cb561ad1?w=800&h=600&fit=crop",
      // EXEMPLE : Vidéo de couverture (la card affichera cette vidéo au lieu de l'image)
      coverVideo: "https://www.youtube.com/watch?v=SJsH92dsBDU",
      // Galerie avec images ET vidéos
      media: [
        { type: 'video', url: 'https://www.youtube.com/watch?v=SJsH92dsBDU', title: 'Présentation du service' },
        { type: 'image', url: 'https://images.unsplash.com/photo-1555939594-58d7cb561ad1?w=1200&h=800&fit=crop' },
        { type: 'image', url: 'https://images.unsplash.com/photo-1567620905732-2d1ec7ab7445?w=1200&h=800&fit=crop' },
        { type: 'image', url: 'https://images.unsplash.com/photo-1546069901-ba9599a7e63c?w=1200&h=800&fit=crop' },
        { type: 'image', url: 'https://images.unsplash.com/photo-1504674900247-0877df9cc836?w=1200&h=800&fit=crop' },
        { type: 'image', url: 'https://images.unsplash.com/photo-1512621776951-a57141f2eefd?w=1200&h=800&fit=crop' },
        { type: 'image', url: 'https://images.unsplash.com/photo-1540189549336-e6e99c3679fe?w=1200&h=800&fit=crop' },
        { type: 'image', url: 'https://images.unsplash.com/photo-1565299624946-b28f40a0ae38?w=1200&h=800&fit=crop' },
        { type: 'image', url: 'https://images.unsplash.com/photo-1547592180-85f173990554?w=1200&h=800&fit=crop' },
        { type: 'image', url: 'https://images.unsplash.com/photo-1490645935967-10de6ba17061?w=1200&h=800&fit=crop' }
      ]
    }
  ],

  // GALERIE DE PLATS - Vos créations culinaires
  dishes: [
    {
      id: 1,
      name: "Pâtes crémeuses au chou-fleur",
      image: "https://images.unsplash.com/photo-1621996346565-e3dbc646d9a9?w=800&h=800&fit=crop"
    }
  ],

  recipes: [
    {
      id: 1,
      title: "Pâtes crémeuses au chou-fleur et épinards",
      description: "Un plat réconfortant et nutritif, parfait pour les grandes quantités. Sauce crémeuse à base de chou-fleur et épinards frais.",
      servings: "50 personnes",
      prepTime: "45 min",
      category: "Plats principaux",
      season: "Toute l'année",
      image: "https://images.unsplash.com/photo-1679556217543-c0cc895892f5?w=800&h=600&fit=crop"
    }
  ],

  testimonials: [
    {
      id: 1,
      client: "Playfight international",
      text: "Chris and Kamil have cooked for several of our events over the years. Beyond their delicious and inspiring cooking — I still use their sunflower and tomato spread after four years — what touches me most is the way they integrate into the group with such sensitivity. They are present without intruding, kind and supportive, and they carry a warm, grounded spirit. Their presence makes meal times feel nourishing on every level, and the food moments especially rich and enjoyable.",
      author: "Alice Muehlroth",
      role: "Directrice RH & évènementiel"
    },
    {
      id: 2,
      client: "Fertile",
      text: "C'était l'idéal pour notre stage. Un lieu convivial pour se réunir, une cuisine variée, pleine de saveurs et de sens : de saison et durable. Une démarche qui résonne avec nos valeurs.",
      author: "Felix de Monts",
      role: "Responsable formation"
    },
    {
      id: 3,
      client: "Le camp climat 2025",
      text: "J'ai vraiment apprécié votre capacité à vous adapter à l'orga, aux recettes, aux produits dispos ou pas, aux bénévoles présent-es, au nombre de repas su au dernier moment etc. C'était très confortable de pouvoir me reposer sur votre maîtrise du sujet. J'ai personnellement adoré le chili et j'ai eu plein de bons retours sur les pâtes bolo ! (une rumeur dit qu'elles ont été faites par un chef italien)",
      author: "Eloise",
      role: "Responsable & Organisatrice de l'événement"
    }
    
  ]
};
